"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.3476 3.77381C19.0527 3.90461 18.7495 4.01501 18.4396 4.10463C18.8064 3.68981 19.0861 3.20171 19.2568 2.66759C19.2951 2.54787 19.2554 2.41682 19.157 2.33852C19.0587 2.26016 18.9222 2.25077 18.814 2.3149C18.156 2.70514 17.4461 2.98558 16.7018 3.14957C15.952 2.41694 14.9337 2 13.881 2C11.6588 2 9.85087 3.80784 9.85087 6.02996C9.85087 6.20497 9.86196 6.37901 9.88388 6.55063C7.12637 6.30852 4.56276 4.95317 2.80234 2.79373C2.7396 2.71677 2.64295 2.67528 2.544 2.68322C2.44499 2.69097 2.35603 2.7468 2.30601 2.83261C1.94896 3.44528 1.7602 4.146 1.7602 4.85895C1.7602 5.82999 2.10689 6.75132 2.71932 7.47124C2.5331 7.40674 2.3524 7.32614 2.17993 7.2304C2.08733 7.17886 1.97433 7.17965 1.88234 7.2324C1.7903 7.28514 1.73258 7.38216 1.73016 7.48819C1.72974 7.50606 1.72974 7.52392 1.72974 7.54203C1.72974 8.99149 2.50985 10.2965 3.70254 11.0077C3.60007 10.9975 3.49767 10.9826 3.39593 10.9632C3.29105 10.9432 3.18319 10.9799 3.11246 11.0599C3.04161 11.1398 3.01817 11.2513 3.05081 11.353C3.49228 12.7313 4.62889 13.7451 6.00296 14.0542C4.86331 14.768 3.56004 15.1419 2.19192 15.1419C1.90645 15.1419 1.61934 15.1251 1.33835 15.0919C1.19876 15.0753 1.06529 15.1577 1.01776 15.2904C0.970218 15.4232 1.0206 15.5713 1.13936 15.6474C2.89693 16.7743 4.9292 17.37 7.01633 17.37C11.1194 17.37 13.6861 15.4352 15.1168 13.812C16.9009 11.7881 17.9241 9.10921 17.9241 6.46228C17.9241 6.3517 17.9224 6.24003 17.919 6.12873C18.6228 5.59842 19.2288 4.95663 19.722 4.21897C19.7969 4.10694 19.7888 3.95887 19.702 3.85574C19.6153 3.75255 19.4709 3.71918 19.3476 3.77381Z",
    fill: fill
  }));
};

exports["default"] = _default;